import { task } from "globals/task";

export default function reset() {
  task.reload();
}
